import { Component, Input, OnInit } from '@angular/core';
import { TextSearchPatternOrItemList } from '../../../models/net/text-search-pattern-or-item-list';
import { TextSearchPatternOrItemListType } from '../../../models/enums/text-search-pattern-or-item-list-type';
import { Primitive } from '../../../models/app/primitive';
import { NameValuePair } from '../../../models/app/name-value-pair';

@Component({
    selector: 'app-text-or-item-list-search-field',
    templateUrl: './text-or-item-list-search-field.component.html',
    styleUrls: ['./text-or-item-list-search-field.component.css', '../../../app.component.css']
})

export class TextOrItemListSearchFieldComponent implements OnInit {

    public searchTypes: NameValuePair[];
    public selectedSearchType: TextSearchPatternOrItemListType = TextSearchPatternOrItemListType.TextSearchPattern;

    @Input() public label: string = "";
    @Input() public placeholder: string = "";
    @Input() public textSearchPatternOrItemList: TextSearchPatternOrItemList = new TextSearchPatternOrItemList();

    public constructor() {

        this.searchTypes = this.getSearchTypeNameValuePairs();
    }

    public ngOnInit(): void { }

    public onSearchTypeChange(searchType: any) {

        this.selectedSearchType = searchType;
    }

    public getSearchTypeNameValuePairs = (): NameValuePair[] => {

        let result: NameValuePair[] = [];

        const enumNames = Object.values(TextSearchPatternOrItemListType).filter(value => typeof value === 'string');
        const enumValues = Object.values(TextSearchPatternOrItemListType).filter(value => typeof value === 'number');

        for (let i = 0; i < enumNames.length; i++) {

            let nameValuePair = new NameValuePair();

            nameValuePair.Name = enumNames[i].toString();
            nameValuePair.Value = enumValues[i].toString();

            result.push(nameValuePair);
        }

        return result;
    }
}
